export const headCellMovileProduct = [
  { id: "", disablePadding: false, label: "" },
  { id: "imeiCode", disablePadding: false, label: "Código IMEI" },
  { id: "capacity", disablePadding: false, label: "Capacidad" },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "color", disablePadding: false, label: "Color" },
  { id: "cost", disablePadding: false, label: "Costo" },
  { id: "price", disablePadding: false, label: "Precio" },
  { id: "discount", disablePadding: false, label: "Descuento" },
  { id: "available", disablePadding: false, label: "Sucursal" },
];
